import { render, staticRenderFns } from "./redpacketStatistics.vue?vue&type=template&id=3344bfe0&scoped=true&"
import script from "./redpacketStatistics.vue?vue&type=script&lang=js&"
export * from "./redpacketStatistics.vue?vue&type=script&lang=js&"
import style0 from "./redpacketStatistics.vue?vue&type=style&index=0&id=3344bfe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3344bfe0",
  null
  
)

export default component.exports